import SETTINGS from './settings.gql';
import CALCULATE_LOAN_VOLTZ from './calculateLoanVoltz.gql';

export { SETTINGS, CALCULATE_LOAN_VOLTZ };
